// import { QuotationAgentDO,QuotationCoverageDO, QuotationClientDO,QuotationPaymentDO,QuotationAdditionalFieldDO, BaseDO, QuotationPremiumBreakupDO, QuotationPremiumSummaryDO, QuotationTripDO} from './';

import { QuotationAgentDO } from './quotationAgent.model';
import { QuotationCoverageDO } from './quotationCoverage.model';
import { QuotationClientDO } from './quotationClient.model';
import { QuotationPaymentDO } from './quotationPayment.model';
import { QuotationAdditionalFieldDO } from './quotationAdditionalField.model';
import { BaseDO } from './base.model';
import { QuotationPremiumBreakupDO } from './QuotationPremiumBreakup.model';
import { QuotationPremiumSummaryDO } from './QuotationPremiumSummary.model';
import { QuotationTripDO } from './QuotationTrip.model';

export class QuotationDO extends BaseDO {
	// public leadRefNum:string;
	// public quotationRefNum:string;
	// public policyCovergeList:PolicyCoverageDO[];
	// public proposalClients:PolicyClientDO[];
	// public policyAgentList:PolicyAgentDO[];
	// //public proposalPayments:PolicyPaymentDO[];

	// public setProposalClients( proposalClients:PolicyClientDO[]){
	//   this.proposalClients = proposalClients;
	// }


	// public setPolicyCovergeList( proposalCoverages:PolicyCoverageDO[]){
	//   this.policyCovergeList = proposalCoverages;
	// }



	public id: Number = null;

	public leadRefNum: String = null;

	public quotationRefNum: String = null;

	public proposalRefNum: String = null;

	public proposalNum: String = null;

	public policyNum: String = null;

	public proposalEntryDt: Date = null;

	public proposalReceivedDt: Date = null;

	public proposalSignedDt: Date = null;

	public policyCommencementDt: Date = null;

	public policyExpiryDt: Date = null;

	public policyIssueDt: Date = null;

	public purposeOfInsuranceCd: String = null;

	public submissionModeCd: String = null;

	public policyTypeCd: String = null;

	public baseProductFamilyCd: String = null;

	public baseProductCd: String = null;

	public baseProductTypeCd: String = null;

	public productPlanOptionCd: String = null;

	public baseProductVersion: Number = null;

	public baseAgentId: String = null;

	public statusCd: String = null;

	public processStatusCd: String = null;

	public stageCd: String = null;

	public validationStatusCd: String = null;

	public uwDecisionCd: String = null;

	public uwDecisionValue: String = null;

	public uwDecisionDt: Date = null;

	public workFlowDecisionCd: String = null;

	public finalSumInsured: any = null;

	public finalPremium: any = null;

	public premiumStatusCd: String = null;

	public policyterm: any = null;

	public ruleEffectiveDate: any = null;

	public underwitingTypeCd: String = null;

	public ratingTypeCd: String = null;

	public coResponseCd: String = null;

	public primaryInsuredValue: any = null;

	public estimatedPrimaryInsuredValue: any = null;

	public totOtherInsurableValue: any = null;

	public sumInsured: any = null;

	public promoCode: String = null;

	public quotationClientList: QuotationClientDO[] = [];

	public quotationCoverageList: QuotationCoverageDO[] = [];

	public quotationAgentList: QuotationAgentDO[] = [];

	public quotationPaymentList: QuotationPaymentDO[] = [];

	public quotationAdditionalFieldList: QuotationAdditionalFieldDO[] = [];

	public premiumBreakupList: QuotationPremiumBreakupDO[] = [new QuotationPremiumBreakupDO()];

	public quotationPremiumSummaryList: QuotationPremiumSummaryDO[] = [new QuotationPremiumSummaryDO()];
	// public  policyTripDO:PolicyTripDO=new PolicyTripDO();

	public quotationTripDO: QuotationTripDO = null;

	public currencyCd: any = null;

	public dueDt: any = null;

	public getId() {
		return this.id;
	}
	public setId(id: Number) {
		this.id = id;
	}
	public getPolicyNum() {
		return this.policyNum;
	}
	public setPolicyNum(policyNum: String) {
		this.policyNum = policyNum;
	}
	public getPolicyIssueDt() {
		return this.policyIssueDt;
	}
	public setPolicyIssueDt(policyIssueDt: Date) {
		this.policyIssueDt = policyIssueDt;
	}
	public getProposalEntryDt() {
		return this.proposalEntryDt;
	}
	public setProposalEntryDt(proposalEntryDt: Date) {
		this.proposalEntryDt = proposalEntryDt;
	}
	public getProposalNum() {
		return this.proposalNum;
	}
	public setProposalNum(proposalNum: String) {
		this.proposalNum = proposalNum;
	}
	public getProposalReceivedDt() {
		return this.proposalReceivedDt;
	}
	public setProposalReceivedDt(proposalReceivedDt: Date) {
		this.proposalReceivedDt = proposalReceivedDt;
	}
	public getProposalSignedDt() {
		return this.proposalSignedDt;
	}
	public setProposalSignedDt(proposalSignedDt: Date) {
		this.proposalSignedDt = proposalSignedDt;
	}
	public getPolicyCommencementDt() {
		return this.policyCommencementDt;
	}
	public setPolicyCommencementDt(policyCommencementDt: Date) {
		this.policyCommencementDt = policyCommencementDt;
	}
	public getPolicyExpiryDt() {
		return this.policyExpiryDt;
	}
	public setPolicyExpiryDt(policyExpiryDt: Date) {
		this.policyExpiryDt = policyExpiryDt;
	}
	public getPurposeOfInsuranceCd() {
		return this.purposeOfInsuranceCd;
	}
	public setPurposeOfInsuranceCd(purposeOfInsuranceCd: String) {
		this.purposeOfInsuranceCd = purposeOfInsuranceCd;
	}
	public getQuotationRefNum() {
		return this.quotationRefNum;
	}
	public setQuotationRefNum(quotationRefNum: String) {
		this.quotationRefNum = quotationRefNum;
	}
	public getSubmissionModeCd() {
		return this.submissionModeCd;
	}
	public setSubmissionModeCd(submissionModeCd: String) {
		this.submissionModeCd = submissionModeCd;
	}
	public getProposalRefNum() {
		return this.proposalRefNum;
	}
	public setProposalRefNum(proposalRefNum: String) {
		this.proposalRefNum = proposalRefNum;
	}
	public getBaseProductFamilyCd() {
		return this.baseProductFamilyCd;
	}
	public setBaseProductFamilyCd(baseProductFamilyCd: String) {
		this.baseProductFamilyCd = baseProductFamilyCd;
	}
	public getBaseProductCd() {
		return this.baseProductCd;
	}
	public setBaseProductCd(baseProductCd: String) {
		this.baseProductCd = baseProductCd;
	}
	public getBaseProductTypeCd() {
		return this.baseProductTypeCd;
	}
	public setBaseProductTypeCd(baseProductTypeCd: String) {
		this.baseProductTypeCd = baseProductTypeCd;
	}
	public getProductPlanOptionCd() {
		return this.productPlanOptionCd;
	}
	public setProductPlanOptionCd(productPlanOptionCd: String) {
		this.productPlanOptionCd = productPlanOptionCd;
	}
	public getPolicyTypeCd() {
		return this.policyTypeCd;
	}
	public setPolicyTypeCd(policyTypeCd: String) {
		this.policyTypeCd = policyTypeCd;
	}

	public getStatusCd() {
		return this.statusCd;
	}
	public setStatusCd(statusCd: String) {
		this.statusCd = statusCd;
	}
	public getProcessStatusCd() {
		return this.processStatusCd;
	}
	public setProcessStatusCd(processStatusCd: String) {
		this.processStatusCd = processStatusCd;
	}
	public getStageCd() {
		return this.stageCd;
	}
	public setStageCd(stageCd: String) {
		this.stageCd = stageCd;
	}
	public getUwDecisionCd() {
		return this.uwDecisionCd;
	}
	public setUwDecisionCd(uwDecisionCd: String) {
		this.uwDecisionCd = uwDecisionCd;
	}
	public getUwDecisionValue() {
		return this.uwDecisionValue;
	}
	public setUwDecisionValue(uwDecisionValue: String) {
		this.uwDecisionValue = uwDecisionValue;
	}
	public getUwDecisionDt() {
		return this.uwDecisionDt;
	}
	public setUwDecisionDt(uwDecisionDt: Date) {
		this.uwDecisionDt = uwDecisionDt;
	}
	public getWorkFlowDecisionCd() {
		return this.workFlowDecisionCd;
	}
	public setWorkFlowDecisionCd(workFlowDecisionCd: String) {
		this.workFlowDecisionCd = workFlowDecisionCd;
	}
	public getPremiumStatusCd() {
		return this.premiumStatusCd;
	}
	public setPremiumStatusCd(premiumStatusCd: String) {
		this.premiumStatusCd = premiumStatusCd;
	}
	public getValidationStatusCd() {
		return this.validationStatusCd;
	}
	public setValidationStatusCd(validationStatusCd: String) {
		this.validationStatusCd = validationStatusCd;
	}


	public getQuotationCoverageList() {
		return this.quotationCoverageList;
	}
	public setQuotationCoverageList(quotationCoverageList: QuotationCoverageDO[]) {
		this.quotationCoverageList = quotationCoverageList;
	}
	public getQuotationAgentList() {
		return this.quotationAgentList;
	}
	public setQuotationAgentList(quotationAgentList: QuotationAgentDO[]) {
		this.quotationAgentList = quotationAgentList;
	}
	public getQuotationPaymentList() {
		return this.quotationPaymentList;
	}
	public setQuotationPaymentList(quotationPaymentList: QuotationPaymentDO[]) {
		this.quotationPaymentList = quotationPaymentList;
	}
	public getQuotationClientList() {
		return this.quotationClientList;
	}
	public setQuotationClientList(quotationClientList: QuotationClientDO[]) {
		this.quotationClientList = quotationClientList;
	}
	public getQuotationAdditionalFieldList() {
		return this.quotationAdditionalFieldList;
	}
	public setQuotationAdditionalFieldList(quotationAdditionalFieldList: QuotationAdditionalFieldDO[]) {
		this.quotationAdditionalFieldList = quotationAdditionalFieldList;
	}
	public getBaseProductVersion() {
		return this.baseProductVersion;
	}
	public setBaseProductVersion(baseProductVersion: Number) {
		this.baseProductVersion = baseProductVersion;
	}

	public getFinalSumInsured() {
		return this.finalSumInsured;
	}
	public setFinalSumInsured(finalSumInsured: Number) {
		this.finalSumInsured = finalSumInsured;
	}

	public getRuleEffectiveDate() {
		return this.ruleEffectiveDate;
	}
	public setRuleEffectiveDate(ruleEffectiveDate: Number) {
		this.ruleEffectiveDate = ruleEffectiveDate;
	}

	// public  getObjectName() {
	// 	return this.PolicyDO.class.getSimpleName();
	// }

	public getFinalPremium() {
		return this.finalPremium;
	}
	public setFinalPremium(finalPremium: Number) {
		this.finalPremium = finalPremium;
	}

	public getPolicyterm() {
		return this.policyterm;
	}
	public setPolicyterm(policyterm: Number) {
		this.policyterm = policyterm;
	}
	public getBasePlan(): QuotationCoverageDO {

		let coverage = new QuotationCoverageDO();
		if (this.quotationCoverageList != null && this.quotationCoverageList.length > 0) {
			for (let tempCoverageDO of this.quotationCoverageList) {
				//			if("BASEPLAN".equals.getPlanTypeCd())){
				//				return this;
				//			}

				if (tempCoverageDO.getPlanTypeCd() != null && tempCoverageDO.getPlanTypeCd() == "BASEPLAN") {
					coverage = tempCoverageDO;
					return coverage;
				}
			}
		}

		return null;

	}
	public getLeadRefNum() {
		return this.leadRefNum;
	}
	public setLeadRefNum(leadRefNum: String) {
		this.leadRefNum = leadRefNum;
	}
	public getBaseAgentId() {
		return this.baseAgentId;
	}
	public setBaseAgentId(baseAgentId: String) {
		this.baseAgentId = baseAgentId;
	}

	public getUnderwitingTypeCd() {
		return this.underwitingTypeCd;
	}
	public setUnderwitingTypeCd(underwitingTypeCd: String) {
		this.underwitingTypeCd = underwitingTypeCd;
	}

	public getCurrencyCd() {
		return this.currencyCd;
	}
	public setCurrencyCd(currencyCd: any) {
		this.currencyCd = currencyCd;
	}

	public getDueDt() {
		return this.dueDt;
	}

	public setDueDt(dueDt: any) {
		this.dueDt = dueDt;
	}
	
}

//}
